<template>
  <div class="view-wrapper">
    <div class="botoes-topo-container elevation-2">
      <v-btn class="botao-pesquisa-triplo" dark color="primary" @click="acaoFinanceiro">
        <v-icon>mdi-currency-usd</v-icon>
      </v-btn>
      <v-btn class="botao-pesquisa-triplo" dark color="primary" @click="acaoHistorico">
        <v-icon>mdi-cash-register</v-icon>
      </v-btn>
      <v-btn class="botao-pesquisa-triplo" dark color="primary" @click="acaoMotivo">
        <v-icon>mdi-circle</v-icon>
      </v-btn>
    </div>

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">

      <div class="mb-2">
        <v-text-field
          v-model="filtroCidade"
          label="Filtrar por Cidade"
          outlined
          dense
          clearable
          hide-details
          placeholder="Digite a cidade..."
        ></v-text-field>
      </div>
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="aoMudarTipoBusca"
      >
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
        <v-radio label="Razão" value="razao" color="primary"></v-radio>
        <v-radio label="Fantasia" value="fantasia" color="primary"></v-radio>
        <v-radio label="CNPJ/CPF" value="cnpj" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <v-card class="d-flex flex-column fill-height">
        
        <div v-if="loadingInicial" class="text-center pa-8 flex-grow-1">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-4 mb-0">Carregando clientes...</p>
        </div>

        <div v-else-if="!loadingInicial && resultados.length === 0" class="text-center pa-8 flex-grow-1">
          <p class="mb-0">Nenhum resultado encontrado. Dê carga para ter resultados</p>
        </div>

        <RecycleScroller
          v-else
          ref="scrollerComponent"  class="scroller"
          :items="resultados"
          :item-size="190" 
          key-field="idcliente"
          v-slot="{ item }"
        >
          <div class="list-item-wrapper" style="height: 190px; border-bottom: 1px solid #e0e0e0;">
            <v-list-item
              class="list resultado-item-clicavel px-2 fill-height"
              :class="{ 'item-selecionado': itemSelecionado === item }"
              @click="selecionarEVoltar(item)"
            >
              <v-list-item-action class="mr-2 align-self-center" @click.stop>
                <v-checkbox
                  :input-value="itemSelecionado === item"
                  @change="toggleSelecao(item)"
                  color="primary"
                ></v-checkbox>
              </v-list-item-action>
              
              <v-list-item-content>
                <v-list-item-title :class="itemCor(item)" class="font-weight-medium text-wrap text-justify" 
                  style="height: auto; line-height: 1.5rem; word-break: break-word;">
                  {{ item.idcliente }} - {{ item.nome }}
                </v-list-item-title>

                <v-list-item-subtitle v-if="item.nomefantasia">
                  {{ item.nomefantasia }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.endereco || item.bairro">
                  {{ item.endereco || '' }}
                  <span v-if="item.endereco && item.bairro"> - </span>
                  {{ item.bairro || '' }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.cidade || item.uf">
                  {{ item.cidade || '' }}
                  <span v-if="item.cidade && item.uf"> - </span>
                  {{ item.uf || '' }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.cnpjCpf || item.inscricaoEstadual">
                  <span v-if="item.cnpjCpf">
                      {{ formatarCpfCnpj(item.cnpjCpf) }}
                  </span>
                  <span v-if="item.inscricaoEstadual && item.inscricaoEstadual !== 'ISENTO'">
                      <span v-if="item.cnpjCpf"> - </span> IE: {{ item.inscricaoEstadual }}
                  </span>
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.fone">
                  Fone: {{ item.fone }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.qtdeVDA">
                  Qtd Vendas: {{ item.qtdeVDA }}
                </v-list-item-subtitle>

                <v-list-item-subtitle v-if="item.priVDA || item.ultVDA">
                  <span v-if="item.priVDA">1ª Venda: {{ FormataDataGeral(item.priVDA) }}</span>
                  <span v-if="item.priVDA && item.ultVDA"> | </span>
                  <span v-if="item.ultVDA">Últ. Venda: {{ FormataDataGeral(item.ultVDA) }}</span>
                </v-list-item-subtitle>

              </v-list-item-content>

              <v-list-item-action class="align-self-center">
                <v-btn icon @click.stop="verVisitaCliente(item)">
                  <v-icon color="primary">mdi-map-marker</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </RecycleScroller>
      </v-card>
    </div>

    <v-dialog v-model="dialogBloqueio" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">Cliente Bloqueado</v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">{{ motivoBloqueio }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogBloqueio = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmacaoRestricao" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-alert</v-icon>
          Restrição Encontrada
        </v-card-title>
        
        <v-card-text class="pt-4 text-body-1 black--text">
          <p>Este cliente possui a seguinte observação:</p>
          <p class="font-weight-bold">{{ mensagemRestricaoConfirmacao }}</p>
          <p class="mb-0">Deseja selecioná-lo mesmo assim?</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="dialogConfirmacaoRestricao = false">Cancelar</v-btn>
          <v-btn color="primary" depressed @click="confirmarSelecaoRestrita">Sim, Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Vue from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import db from '@/plugins/dexie';
import moment from 'moment';
import storage from '@/services/storage';
import { PESQUISA_CADASTRO_CLIENTE_STORAGE } from '@/constants/STORAGE';

Vue.use(VueVirtualScroller);

export default {
  name: 'ViewPesquisaCliente',

  data() {
    return {
      loadingInicial: true,
      itemSelecionado: null,
      resultados: [],
      
      dialogBloqueio: false,
      motivoBloqueio: '',
      currentSearchId: 0,
      idVendedorLogado: null,

      dialogConfirmacaoRestricao: false,
      mensagemRestricaoConfirmacao: '',
      clientePendenteSelecao: null,
      
      termoBusca: this.$route.query.busca || '', 
      tipoBusca: this.$route.query.tipoBusca || 'razao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer', 

      filtroCidade: this.$route.query.cidade || '',
    };
  },

  computed: {
    labelBusca() {
      switch (this.tipoBusca) {
        case 'codigo': return 'Buscar por Código';
        case 'cnpj': return 'Buscar por CNPJ ou CPF';
        case 'fantasia': return 'Buscar por Nome Fantasia';
        case 'razao':
        default: return 'Buscar por Razão Social';
      }
    }
  },

  watch: {
    '$route.query.cidade'(novaCidade) {
      this.filtroCidade = novaCidade || '';
    },

    '$route.query': {
      immediate: true,
      deep: true,
      handler(newQuery, oldQuery) {
        if (oldQuery) {
          const filtrosImportantes = ['codigopessoa', 'nome', 'cnpj', 'fantasia', 'cidade', 'semVendas', 'busca', 'tipoBusca', 'modoBusca'];
          const mudouFiltro = filtrosImportantes.some(key => newQuery[key] !== oldQuery[key]);
          if (mudouFiltro) {
            sessionStorage.removeItem('listaClientesScrollPos');
          }
        }

        if (!oldQuery) {
          this.iniciarProcesso();
          return;
        }
        
        const filtrosImportantes = ['codigopessoa', 'nome', 'cnpj', 'fantasia', 'cidade', 'semVendas', 'busca', 'tipoBusca', 'modoBusca'];
        const mudouFiltro = filtrosImportantes.some(key => newQuery[key] !== oldQuery[key]);

        if (mudouFiltro || this.resultados.length === 0) {
          this.iniciarProcesso();
        } else {
          this.restaurarSelecaoDaUrl();
        }
      },
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollerComponent && this.$refs.scrollerComponent.$el) {
      const scrollPos = this.$refs.scrollerComponent.$el.scrollTop;
      sessionStorage.setItem('listaClientesScrollPos', scrollPos);
    }

    const rotasDeDetalhe = ['/pesquisa-financeiro-cliente', '/pesquisa_visita_cliente'];
    const indoParaDetalhe = rotasDeDetalhe.some(rota => to.path.includes(rota));

    if (!indoParaDetalhe) {
      storage.removeItem(PESQUISA_CADASTRO_CLIENTE_STORAGE.textofiltro);
      sessionStorage.removeItem('listaClientesScrollPos');
    }
    next();
  },

  created() {
    sessionStorage.removeItem('filtro_historico_produto');
    sessionStorage.removeItem('produto_selecionado_retorno');
  },

  methods: {

    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
    },

    aoMudarTipoBusca() {
      this.focarInputBusca();
      this.ordenarResultados();
    },

    ordenarResultados() {
      if (!this.resultados || this.resultados.length === 0) return;

      this.resultados.sort((a, b) => {
        if (this.tipoBusca === 'codigo') {
          const codA = (a.idcliente || '').toString();
          const codB = (b.idcliente || '').toString();
          return codA.localeCompare(codB, undefined, { numeric: true });
        } 
        else if (this.tipoBusca === 'fantasia') {
          const fantA = (a.nomefantasia || '').toString().toLowerCase();
          const fantB = (b.nomefantasia || '').toString().toLowerCase();
          return fantA.localeCompare(fantB, 'pt-BR', { sensitivity: 'base' });
        } 
        else if (this.tipoBusca === 'cnpj') {
          const cnpjA = (a.cnpjCpf || '').toString();
          const cnpjB = (b.cnpjCpf || '').toString();
          return cnpjA.localeCompare(cnpjB, undefined, { numeric: true });
        } 
        else {
          const nomeA = (a.nome || '').toString().toLowerCase();
          const nomeB = (b.nome || '').toString().toLowerCase();
          return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
        }
      });
    },

    async obterVendedorLogado() {
      try {
        const param = await db.parametro.toCollection().first();
        if (param) {
          this.idVendedorLogado = param.idvendedorlogado; 
        }
      } catch (e) {
        console.error("Erro ao obter idvendedorlogado:", e);
      }
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';
      
      const cidadeLimpa = this.filtroCidade ? this.filtroCidade.trim() : '';

      if (cidadeLimpa !== '') {
        query.cidade = cidadeLimpa;
      } else {
        delete query.cidade;
      }
      
      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }
      
      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca ||
          this.$route.query.cidade !== query.cidade) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.currentSearchId = Date.now();
      this.resultados = [];
      this.itemSelecionado = null;
      this.loadingInicial = true;

      await this.obterVendedorLogado(); 

      await this.carregarPaginaVisualizacao();

      this.loadingInicial = false; 
      this.restaurarPosicaoScroll();
    },

    restaurarPosicaoScroll() {
      const posSalva = sessionStorage.getItem('listaClientesScrollPos');
      
      if (posSalva && this.resultados.length > 0) {
        setTimeout(() => {
          const scroller = this.$refs.scrollerComponent;
          if (scroller && scroller.$el) {
            scroller.$el.scrollTop = parseInt(posSalva);
          }
        }, 100); 
      }
    },

    async carregarPaginaVisualizacao() {
      const { codigopessoa, nome, cnpj, fantasia, cidade, semVendas, busca, tipoBusca, modoBusca } = this.$route.query;

      try {
        const idBusca = codigopessoa ? parseInt(codigopessoa) : 0;
        const nomeBusca = nome ? nome.trim().toLowerCase() : null;
        const fantasiaBusca = fantasia ? fantasia.trim().toLowerCase() : null;
        const cidadeLower = cidade ? cidade.toLowerCase() : null;
        const cnpjLimpo = cnpj ? cnpj.replace(/\D/g, '') : null;
        
        const termoGlobal = busca ? busca.trim() : null;
        const tipoBuscaAtivo = tipoBusca || 'razao';
        const modoBuscaAtivo = modoBusca || 'qualquer';
        
        let dataLimiteTimestamp = null;
        if (semVendas) {
          const dias = parseInt(semVendas) || 0;
          if (dias > 0) {
            const d = new Date();
            d.setHours(0, 0, 0, 0);
            d.setDate(d.getDate() - dias);
            dataLimiteTimestamp = d.getTime();
          }
        }

        let collection;
        let jaEstaOrdenado = false;

        if (termoGlobal) {
          collection = db.cliente.orderBy('nome');
          jaEstaOrdenado = true;
        } 
        else if (idBusca > 0) {
          collection = db.cliente.where('idcliente').equals(idBusca);
        } else if (nomeBusca && !fantasiaBusca) {
          collection = db.cliente.where('nome').startsWithIgnoreCase(nomeBusca);
          jaEstaOrdenado = true;
        } else if (fantasiaBusca) {
          collection = db.cliente.where('nomefantasia').startsWithIgnoreCase(fantasiaBusca);
        } else {
          collection = db.cliente.orderBy('nome');
          jaEstaOrdenado = true;
        }

        collection = collection.filter(c => c.idcliente && c.nome);

        let clientes = await collection.toArray();

        if (this.idVendedorLogado) {
          clientes = clientes.filter(c => c.idvendedor === this.idVendedorLogado);
        }

        if (nomeBusca || fantasiaBusca || cnpjLimpo || cidadeLower || dataLimiteTimestamp !== null || termoGlobal) {
          clientes = clientes.filter(c => {
            let match = true;

            if (nomeBusca && !c.nome?.toLowerCase().includes(nomeBusca)) match = false;
            if (match && fantasiaBusca && !c.nomefantasia?.toLowerCase().includes(fantasiaBusca)) match = false;
            if (match && cnpjLimpo) {
                const dbCnpj = c.cnpjCpf ? c.cnpjCpf.replace(/\D/g, '') : '';
                if (!dbCnpj.includes(cnpjLimpo)) match = false;
            }
            if (match && cidadeLower) {
                if (!c.cidade || !c.cidade.toLowerCase().includes(cidadeLower)) match = false;
            }

            if (match && dataLimiteTimestamp !== null) {
                if (!c.ultVDA) return true; 
                
                let dataUltVendaMs = null;
                if (c.ultVDA instanceof Date) {
                    dataUltVendaMs = c.ultVDA.getTime();
                } else if (typeof c.ultVDA === 'string') {
                    if (c.ultVDA.includes('/')) {
                        const partes = c.ultVDA.split('/'); 
                        if (partes.length === 3) {
                          const d = new Date(partes, partes - 1, partes);
                          d.setHours(0,0,0,0);
                          dataUltVendaMs = d.getTime();
                        }
                    } else {
                        const d = new Date(c.ultVDA);
                        if (!isNaN(d.getTime())) {
                            d.setHours(0,0,0,0);
                            dataUltVendaMs = d.getTime();
                        }
                    }
                }

                if (dataUltVendaMs !== null && dataUltVendaMs > dataLimiteTimestamp) {
                    match = false;
                }
            }

            if (match && termoGlobal) {
                const termoAcento = this.removerAcentos(termoGlobal.toLowerCase());
                
                if (tipoBuscaAtivo === 'razao') {
                    const desc = c.nome ? this.removerAcentos(c.nome.toLowerCase()) : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!desc.startsWith(termoAcento)) match = false;
                    } else {
                      if (!desc.includes(termoAcento)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'codigo') {
                    const cod = c.idcliente ? c.idcliente.toString() : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!cod.startsWith(termoGlobal)) match = false;
                    } else {
                      if (!cod.includes(termoGlobal)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'fantasia') {
                    const fant = c.nomefantasia ? this.removerAcentos(c.nomefantasia.toLowerCase()) : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!fant.startsWith(termoAcento)) match = false;
                    } else {
                      if (!fant.includes(termoAcento)) match = false;
                    }
                } 
                else if (tipoBuscaAtivo === 'cnpj') {
                    const termoCnpjLimpo = termoGlobal.replace(/\D/g, '');
                    const dbCnpj = c.cnpjCpf ? c.cnpjCpf.replace(/\D/g, '') : '';
                    if (modoBuscaAtivo === 'inicio') {
                      if (!dbCnpj.startsWith(termoCnpjLimpo)) match = false;
                    } else {
                      if (!dbCnpj.includes(termoCnpjLimpo)) match = false;
                    }
                }
            }

            return match;
          });
        }

        if (!jaEstaOrdenado && clientes.length > 0) {
          clientes.sort((a, b) => {
            const nomeA = (a.nome || '').trim();
            const nomeB = (b.nome || '').trim();
            return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
          });
        }

        this.resultados = clientes;

        this.ordenarResultados();
        
        this.restaurarSelecaoDaUrl();
        return true;

      } catch (error) {
        console.error("Erro na busca local:", error);
        return false;
      }
    },

    restaurarSelecaoDaUrl() {
      const { selecionadoId } = this.$route.query;
      if (selecionadoId && this.resultados.length > 0) {
        const idParaSelecionar = parseInt(selecionadoId);
        const itemEncontrado = this.resultados.find(r => r.idcliente === idParaSelecionar);
        if (itemEncontrado) this.itemSelecionado = itemEncontrado;
      }
    },

    toggleSelecao(item) {
      const novoItem = (this.itemSelecionado === item) ? null : item;
      this.itemSelecionado = novoItem;
      const query = { ...this.$route.query };
      
      if (novoItem) {
        query.selecionadoId = novoItem.idcliente;
      } else {
        delete query.selecionadoId;
      }
      this.$router.replace({ query }).catch(() => {});
    },

    FormataDataGeral(date) {
      return moment.utc(date).format('DD/MM/YYYY');
    },

    itemCor(item) {
      if (item.bloqueado === 'S') return 'red--text text--darken-2 font-weight-bold';
      if (item.restricao && item.restricao.substring(0,1) === '4') return 'orange--text text--darken-2 font-weight-bold';
      if (item.restricao && item.restricao.substring(0,1) !== 'N') return 'red--text text--darken-2 font-weight-bold';
      return ''; 
    },

    formatarCpfCnpj(valor) {
      if (!valor) return '';
      const digitos = valor.replace(/\D/g, '');
      if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      return valor;
    },

    acaoFinanceiro() {
      if (!this.itemSelecionado) return;
      this.$router.push({
        path: '/pesquisa-financeiro-cliente',
        query: { 
          aba: 'financeiro', 
          clienteNome: this.itemSelecionado.nome, 
          clienteCodigo: this.itemSelecionado.idcliente,
          clienteLimite: this.itemSelecionado.limiteCredito, 
          clienteIdVendedor: this.itemSelecionado.idvendedor
        },
      });
    },
    
    acaoHistorico() {
      if (!this.itemSelecionado) return;
      this.$router.push({
        path: '/pesquisa-financeiro-cliente',
        query: { 
          aba: 'vendas',
          origem: 'Pesquisaclientes',
          clienteNome: this.itemSelecionado.nome, 
          clienteCodigo: this.itemSelecionado.idcliente,
          clienteIdVendedor: this.itemSelecionado.idvendedor
        },
      });
    },

    getTextoRestricao(item) {
      const restricao = item.restricao ? item.restricao.trim() : '';
      const codigoRestricao = restricao.length > 0 ? restricao.substring(0, 1) : '';
      
      let msg = '';
      switch (codigoRestricao) {
        case '0': msg = "Cliente Inativo."; break;
        case '1': msg = "Ficha cadastral não aprovada."; break;
        case '2': msg = "LIMITE DE CRÉDITO EXCEDIDO."; break;
        case '3': msg = "Parcela Primeira Compra Aberta."; break;
        case '4': msg = "Financeiro em Atraso."; break;
        case '5': msg = "Cliente com Restrição SPC."; break;
        case '6': msg = "Cliente Bloqueado."; break;
        case '7': msg = "Limite de Crédito Autorizado Excedido."; break;
        case '9': msg = "Cliente possui pré-venda aberta."; break;
        default:
          if (codigoRestricao === 'N' || codigoRestricao === '') return null;
          msg = restricao;
          break;
      }
      return msg;
    },

    selecionarEVoltar(item) {
      if (!item) return;

      if (item.bloqueado === 'S') {
        this.motivoBloqueio = 'Cliente Bloqueado.';
        this.dialogBloqueio = true;
        return;
      }

      const restricao = item.restricao ? item.restricao.trim() : '';
      const char0 = restricao.length > 0 ? restricao.substring(0, 1) : 'N';
      const char1 = restricao.length > 1 ? restricao.substring(1, 2) : '';

      const msgRestricao = this.getTextoRestricao(item);

      if (char0 !== 'N' && char1 === 'N') {
        this.motivoBloqueio = msgRestricao || 'Cliente possui restrição e não pode ser selecionado.';
        this.dialogBloqueio = true;
        return;
      }

      if (char0 !== 'N' && char1 === 'S') {
        this.clientePendenteSelecao = item;
        this.mensagemRestricaoConfirmacao = msgRestricao || '';
        this.dialogConfirmacaoRestricao = true;
        return;
      }

      this.finalizarSelecao(item);
    },

    confirmarSelecaoRestrita() {
      if (this.clientePendenteSelecao) {
        this.finalizarSelecao(this.clientePendenteSelecao, true);
        this.dialogConfirmacaoRestricao = false;
        this.clientePendenteSelecao = null;
      }
    },

    finalizarSelecao(item, restricaoAceita = false) {
      sessionStorage.setItem('pesquisaResultado', JSON.stringify({ 
        tipo: 'Cliente', 
        codigo: item.idcliente,
        descricao: item.nome,
        restricaoAceita: restricaoAceita
      }));
      this.$router.back();
    },

    acaoMotivo() {
      if (!this.itemSelecionado) return;
      
      const msg = this.getTextoRestricao(this.itemSelecionado);
      this.motivoBloqueio = msg || "Não há restrições cadastradas.";
      this.dialogBloqueio = true;
    },
    verVisitaCliente(item) {
      this.$router.push({
        path: '/pesquisa_visita_cliente',
        query: { clienteNome: item.nome, clienteCodigo: item.idcliente },
      });
    },
    voltar() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
}
.botoes-topo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  width: 100%;
  background-color: #f5f5f5;
  flex-shrink: 0;
}
.item-selecionado {
  background-color: #E3F2FD !important;
}
.botao-pesquisa-triplo {
  margin-top: 0px;
  margin-right: 8px;
  margin-left: 8px;
  width: 30.5%;
  display: flex;
  align-items: stretch;
}

.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}
.list{
  background-color: white;
}
::v-deep .v-input--radio-group__input {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 0px !important;
}
</style>